/**
* Product Grid JS
* -----------------------------------------------------------------------------
*
* All the JS for the Product Grid component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger )
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'product-grid',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.product-grid-slider' ).length ) {
        $( '.product-grid-slider' ).each( function( index, element ) {
          const splide = new Splide( element, {
            type: 'loop',
            gap: '2rem',
            perPage: 4,
            perMove: 1,
            pagination: false,
            speed: 800,
            autoHeight: true,
            breakpoints: {
              768: {
                perPage: 1,
              },
            },
          } );
          splide.on( 'overflow', function( isOverflow ) {
            splide.options = {
              arrows: isOverflow,
              drag: isOverflow,
            };
          } );

          splide.mount();
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'product-grid', COMPONENT );
} )( app );
